import { AppBar, Drawer, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import GuiaRecurso from './GuiaRecurso';

const styles = () => ({
  drawerTitle: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
});
class DrawerGuiaOriginal extends React.Component {
  constructor (props) {
    super(props);
  }
  render () {
    const { classes, open, handleClose, guiaOriginal } = this.props;

    return (
      <Drawer
        anchor='left'
        open={open}
        onClose={handleClose}
      >
        <div tabIndex={0} role='button' >
          <AppBar position='sticky' color='default' elevation={0}>
            <div className={classes.drawerTitle}>
              <IconButton
                key='close'
                aria-label='Close'
                color='inherit'
                title='Fechar'
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </AppBar>
            <GuiaRecurso
              loteSelecionado={this.props.loteSelecionado}
              guia={guiaOriginal}
              codGuia={guiaOriginal.codGuia}
              modoEdicaoGuia={this.props.modoEdicaoGuia}
              emAuditoria={true}
              readOnly={true}
            />
        </div>
      </Drawer>
    );
  }
}
export default withStyles(styles)(DrawerGuiaOriginal);
